// The backend returns 12 — the cap of a two-row tile (3 x 2 x 2) — so any size fills without a refetch.
export const DASHBOARD_TILE_NATURAL_ROWS = 3;
